export default {
  id: null,
  usuario: {
    id: null
  }
}



// WEBPACK FOOTER //
// ./src/screens/central/cadastros/para/empty/emptyCadastroBase.js